export default "__VITE_ASSET__QUeIsBtR__"